export const SET_OBJECT_EXPOSURE = 'SET_OBJECT_EXPOSURE';
export const SET_OBJECT_SHADOW_INTENSITY = 'SET_OBJECT_SHADOW_INTENSITY';
export const SET_OBJECT_SHADOW_SOFTNESS = 'SET_OBJECT_SHADOW_SOFTNESS';